import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/about.scss";
import { Link } from "react-router-dom";

function About() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="about">
      <Header />

      <main>
        <section
          id="shopify-section-template--19720760099028__main"
          className="shopify-section section"
        >
          <div className="page-width page-width--narrow section--padding">
            <h1 className="main-page-title page-title h1 text-center">
              <motion-element className="inline-flex" data-motion="fade-up">
                About Us
              </motion-element>
            </h1>
            <br />
            <div className="page__content rte">
              <div style={{ textAlign: "center" }}>
                <img
                  src="/main/a1.webp"
                  alt="Cartnovabin Sexy Shoes"
                  style={{ float: "none" }}
                  width={803}
                  height={561}
                />
              </div>
              <h3 className="about-us-gray" style={{ textAlign: "center" }}>
                <strong />
              </h3>
              <h2 className="about-us-gray" style={{ textAlign: "center" }}>
                <strong>WHO WE ARE</strong>
              </h2>
              <div
                className="about-us-content span8"
                style={{ textAlign: "center" }}
              >
                <p>
                  <span>
                    Cartnovabin is more than a brand; it's a vibrant tapestry
                    woven from the colorful threads of South Africa's rich
                    heritage, culture, and resilient spirit. The brand's very
                    name pays homage to two integral aspects deeply rooted in
                    the founder's upbringing and the nation's history.
                  </span>
                </p>
                <p>
                  <span>
                    Firstly, "Cartnovabin" encapsulates the essence of
                    Cartnovabin Town, a city renowned for its breathtaking
                    beauty, cultural diversity, and creative energy. It
                    represents the vibrancy and dynamism inherent in this
                    coastal metropolis, a place where the collision of cultures,
                    artistry, and innovation is omnipresent. Cartnovabin Town's
                    allure, with its scenic landscapes and diverse communities,
                    serves as a wellspring of inspiration for Cartnovabin's
                    commitment to creativity and inclusivity.
                  </span>
                </p>
                <p>
                  <span style={{ fontWeight: 400 }}>
                    In the ever-evolving world of fashion, we seek to stay ahead
                    of the trends so you can always bring your a-game, whether
                    it's date night, a formal event, or simply hanging out with
                    your girlfriends. We create and design our products in-house
                    to ensure we provide you the best styles and highest quality
                    shoes and accessories.
                  </span>
                </p>
                <p>
                  <span>
                    On the other hand, "Robbin" draws from Robben Island, a
                    historically significant symbol of struggle and triumph.
                    It's where Nelson Mandela, an emblem of courage and
                    resilience, was incarcerated. This island stands as a
                    poignant reminder of South Africa's journey through hardship
                    and the indomitable human spirit. Mandela's unwavering
                    determination to fight for justice and freedom resonates
                    deeply with Cartnovabin's ethos, serving as a beacon of hope
                    and perseverance. His story serves as a guiding light,
                    instilling in the brand the belief that dreams can withstand
                    adversity and flourish against all odds.
                  </span>
                </p>
                <p>
                  <span>
                    The fusion of Cartnovabin Town's vibrancy and the resilience
                    embodied by Robben Island forms the cornerstone of
                    Cartnovabin's identity. It's a testament to the founder's
                    personal journey and the spirit of never surrendering one's
                    dreams, inspired by Mandela's unwavering determination. This
                    fusion fuels the brand's evolution, driving it forward as a
                    testament to the power of resilience, creativity, and the
                    pursuit of dreams against all odds.
                  </span>
                </p>
                <p>
                  Cartnovabin's narrative goes beyond its origin story; it
                  intertwines with a strong commitment to fostering
                  individualism, celebrating diversity, and championing
                  personalization. Embracing the essence of "Be bold, be you,"
                  our brand ethos echoes the vibrant hues of individuality,
                  echoing the diverse tapestry of South Africa's cultural
                  mosaic.
                </p>
                <p style={{ textAlign: "center" }}>
                  &nbsp;
                  <img
                    src="/main/a2.webp"
                    alt="Cartnovabin Sneakers"
                    style={{ float: "none" }}
                    width={803}
                    height={689}
                  />
                </p>
                <h2>
                  <strong />
                </h2>
                <p>
                  <span style={{ fontWeight: 400 }}>
                    Have questions about orders, shipping, or anything
                    footwear-related? Check out our{" "}
                    <Link
                      onClick={toTop}
                      to="/shipping"
                      title="Cartnovabin Shipping Policy"
                    >
                      shipping policy
                    </Link>{" "}
                    and/or{" "}
                    <Link
                      onClick={toTop}
                      to="/contact"
                      title="Cartnovabin Customer Service"
                    >
                      drop us a message
                    </Link>{" "}
                    today.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default About;
